import { BaseService, GET, Header, Path, QueryMap, Signal } from 'ts-retrofit3';

import type { IResponse } from '@/Module/Core/Model/ApiModel';
import { HttpService } from '@/Module/Core/Service';
import { NOTIFICATION_API } from '@/Module/Profile/Constant/NOTIFICATION_API';
import type { IGetAllNotification, IGetTotalNotification } from '@/Module/Profile/Model/ApiModel';
import type { INotification, INotificationAll, ITotalNotification } from '@/Module/Profile/Model/DataModel';

class NotificationService extends BaseService {
  @GET(NOTIFICATION_API.GET_LIST_NOTIFICATION)
  async getListNotification(
    @QueryMap _query: IGetAllNotification,
    @Signal _signal?: AbortSignal,
  ): Promise<IResponse<INotificationAll>> {
    return <IResponse>{};
  }

  @GET(NOTIFICATION_API.GET_READ_NOTIFICATION)
  async getReadNotification(
    @Path('id') _id: INotification['id'],
    @Signal _signal?: AbortSignal,
  ): Promise<IResponse<INotification>> {
    return <IResponse>{};
  }

  @GET(NOTIFICATION_API.GET_TOTAL_NOTIFICATION)
  async getTotalNotification(
    @QueryMap _query: IGetTotalNotification,
    @Signal _signal?: AbortSignal,
    @Header('serverAuthorization') _authorization?: string,
  ): Promise<IResponse<ITotalNotification>> {
    return <IResponse>{};
  }

  @GET(NOTIFICATION_API.GET_READ_ALL_NOTIFICATION)
  async getAllReadNotification(@QueryMap _query: IGetTotalNotification, @Signal _signal?: AbortSignal): Promise<IResponse> {
    return <IResponse>{};
  }
}
export default HttpService.build(NotificationService);
